import {
  getAcademicHierarchyLevelsUrl,
  getAcademicHierarchyUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class AcademicHierarchyService {
  static TOP_LEVEL_ID = "top";
  static IS_ACADEMIC_SUBJECT = "is academic subject";

  static createLevel(parentLevelId, levelName) {
    const params = { parentLevelId: parentLevelId, name: levelName };
    return postRequest(getAcademicHierarchyLevelsUrl(), params);
  }

  static setSubjects(level, subjects) {
    const params = { name: level.name, subjects: subjects };

    return putRequest(
      getAcademicHierarchyLevelsUrl() + "/" + level.ddl_id,
      params
    );
  }

  static deleteLevel(levelId) {
    return deleteRequest(getAcademicHierarchyLevelsUrl() + "/" + levelId);
  }

  static setLevelTitle(levelId, levelTitle) {
    const params = { name: levelTitle };
    return putRequest(getAcademicHierarchyLevelsUrl() + "/" + levelId, params);
  }

  static getLevels = (levelId) => {
    if (!levelId) {
      levelId = this.TOP_LEVEL_ID;
    }
    return getRequest(getAcademicHierarchyLevelsUrl() + "/" + levelId);
  };

  static getLevelsFull = (subjectsIds) => {
    const params = { subjectIds: subjectsIds };
    return getRequest(getAcademicHierarchyUrl() + "/full/levels", params);
  };
}
